<template>
  <v-row
      @click="$emit('click-en-entrega')"
      justify="center" >
    <v-col cols="12">
      <v-sheet elevation="10" rounded="lg" class="blue">
        <v-sheet class="pa-3 primary text-center" dark rounded="lg">
          <v-chip label class="font-weight-bold mx-4"># {{ item.OrdenEntrega }}</v-chip>
          <span class="itemEntrega text-h6">Cliente: <b>{{ item.NombreCliente }}</b></span>
        </v-sheet>

        <v-row class="py-0 my-0">
          <v-col align="center" class="py-0 my-0">
            <h2 class="text-h6 mb-2 itemEntrega">
              Comprobante : {{ item.Comprobante }}
            </h2>

          </v-col>
        </v-row>

        <v-row class="py-0 my-0">
          <v-col align="center" class="py-0 my-0">
            <h2 class="text-h6 mb-2 itemEntrega">
              Destino : {{ item.NombreDestino }}
            </h2>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'CardInfoEntrega',
  props: {
    item: {}
  }
}
</script>
<style scoped>
.itemEntrega {
  color: white;
  font-size: 16px;
  font-weight: 900;
  font-family: "Helvetica Neue";
}
</style>